'use client';

import type { LinkProps } from './types';
import { withLinkMasking } from './withLinkMasking';

function MaskedLink(props: LinkProps) {
  const { href, htmlTag = 'span', ...rest } = props;

  if (href) {
    return (
      <a {...rest} href={href}>
        {props.children}
      </a>
    );
  }
  const Tag = htmlTag;

  return <Tag {...rest}>{props.children}</Tag>;
}

export const LinkWithMasking = withLinkMasking<LinkProps>(MaskedLink);
